import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useLogout from "../../auth/modals/engines/UseLogout";
import useInactivityTimer from "../../auth/modals/engines/UseInactivityTimer";
import Logout from "../../auth/modals/ModalLogoutButton";
import { AuthContext } from "../../auth/providers/AuthProvider";

const InactivityForm = ({ children }) => {
    const navigate = useNavigate();
    const logout = useLogout();
    const { authClaims } = useContext(AuthContext);
    const [modalVisible, setModalVisible] = React.useState(false);
    const [forcedLogout, setForcedLogout] = React.useState(false);

    const handleTimeout = () => {
        setModalVisible(true);
    };

    const handleStayLoggedIn = () => {
        setModalVisible(false);
        setForcedLogout(false);
        resetTimer();
    };

    const handleLogout = () => {
        setModalVisible(false)
        setForcedLogout(true);
    };

    const { resetTimer } = useInactivityTimer(handleTimeout, () => {
        handleLogout();
        logout(navigate, { redirectState: { logoutReason: 'session_expired' } });
    }, authClaims);

    return (
        <>
            {modalVisible && (
                <Logout
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    forcedLogout={forcedLogout}
                    logout={() => logout(navigate)}
                    stayLoggedIn={handleStayLoggedIn}
                />
            )}
            {children}
        </>
    );
};

export default InactivityForm;
